import { AppStoreLink } from "./AppStoreLink";
import { CircleBackground } from "./CircleBackground";
import { Container } from "./Container";
import { Button } from "./Button";
import { Link } from "react-router-dom";

export function CallToAction() {
  return (
    <section
      id="get-started"
      className="relative overflow-hidden bg-gray-900 py-20 sm:py-28"
    >
      <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
        <CircleBackground color="#fff" className="animate-spin-slower" />
      </div>
      <Container className="relative">
        <div className="mx-auto max-w-md sm:text-center">
          <h2 className="text-3xl font-medium tracking-tight text-white sm:text-4xl">
            Try it now
          </h2>
          <p className="mt-4 text-lg text-gray-300">
            Signing up is free. Try Autodo today and see how it can help you
            plan and organize your tasks.
          </p>
          <div className="mt-8 flex justify-center">
            <Button href="/app" color="rose">
              Go to app
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
